import React, { useEffect, useState } from 'react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`sticky top-0 z-40 transition-all duration-300 bg-white ${isScrolled ? 'shadow-md py-3' : 'py-4 md:py-5'}`} data-id="element-102">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-103">
        <a href="#" className="flex items-center" data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/mPSWxYNkSeVkHGPmx5fC8y/transparente-10.png" alt="Centro Formativo Cumbre" className="h-8 md:h-10 object-contain" data-id="element-105" />
        </a>
        <div className="hidden md:flex items-center gap-6" data-id="element-106">
          <a href="#" className="text-brand-black font-medium hover:text-brand-orange transition-colors" data-id="element-107">
            El Sistema
          </a>
          <a href="#" className="text-brand-black font-medium hover:text-brand-orange transition-colors" data-id="element-108">
            Resultados
          </a>
          <a href="#" className="bg-brand-black text-white px-5 py-2 rounded-full font-medium hover:bg-gray-800 transition-colors" data-id="element-109">
            Ingresar ahora
          </a>
        </div>
      </div>
    </nav>;
}